

export interface IncidentReasonDataForm {
    id?: number;
    name?: string; 
    description?: string;
    is_active?: boolean; 
    created_at?: string;
}

export const defaultIncidentReasonDataForm: IncidentReasonDataForm = {
    name: '',
    description: '',
    is_active: true
};

export interface IncidentReasonFilters {
    name?: string; 
    is_active?: boolean;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
